import { siteData } from '@/data/siteData';

const iconMap: Record<string, string> = {
  coffin: '⚰',
  flame: '🔥',
  gravestone: '🪦',
  shield: '🛡️',
};

export function Services() {
  return (
    <section id="services" className="py-20 bg-brand-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            U gerustellende Begrafnisse, Kremasies, Grafstene en Polisse
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {siteData.services.map((service) => (
            <div
              key={service.id}
              className="card-hover bg-white rounded-xl p-8 border border-brand-navy/10"
            >
              <div className="w-12 h-12 bg-brand-gold/10 rounded-lg flex items-center justify-center mb-6 text-2xl">
                {iconMap[service.icon]}
              </div>
              <h3 className="text-xl font-serif font-bold text-brand-navy mb-3">
                {service.title}
              </h3>
              <p className="text-brand-navy/70 text-sm leading-relaxed mb-6">
                {service.description}
              </p>
              <p className="text-xs text-brand-gold font-medium italic uppercase">
                {service.titleAfrikaans}
              </p>
            </div>
          ))}
        </div>

        {/* Funeral Cover Pricing */}
        <div className="mt-16 bg-brand-navy rounded-2xl p-8 md:p-12 text-brand-light text-center">
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-6">
            Uitkeer Polisdekking / Funeral Cover
          </h3>
          <p className="text-brand-light/80 mb-8 max-w-lg mx-auto">
            Maak voorsiening vir u familie met ons 'Uitkeer Polisdekking' en finansiële bystand.
            No waiting period. No hassle.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-8">
            <div className="p-6 border border-brand-gold/30 rounded-xl bg-brand-navy/50">
              <span className="text-brand-gold text-sm uppercase tracking-wider font-semibold block mb-2">
                Individual
              </span>
              <span className="text-3xl font-serif font-bold text-white">{siteData.pricing.individual}</span>
            </div>
            <div className="p-6 border border-brand-gold/30 rounded-xl bg-brand-navy/50">
              <span className="text-brand-gold text-sm uppercase tracking-wider font-semibold block mb-2">
                Family
              </span>
              <span className="text-3xl font-serif font-bold text-white">{siteData.pricing.family}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}